/**
 * The Activity Log row text for a feature-flag usage event (`_to` = `featureFlags/<n>`). Pure, so the row
 * can be tested without rendering the client page (F-206).
 */
export type ActivityEvent = {
  _to: string;
  type?: string | number | null;
  extras?: string | null;
};
export type Translate = (key: string, options?: any) => string;

export const featureFlagRowText = (
  event: ActivityEvent,
  t: Translate,
): string => {
  let parsedExtras = {} as any;
  try {
    parsedExtras = JSON.parse(event?.extras || '');
  } catch (e) {}

  switch (event._to) {
    case 'featureFlags/18':
      return t(`pages.clientsShow.featureFlags.${event._to}`);
    case 'featureFlags/17': {
      return (
        t(`pages.clientsShow.featureFlags.${event._to}`) +
        (parsedExtras?.videoId ? `, videoId: ${parsedExtras.videoId}` : '')
      );
    }
    case 'featureFlags/16':
      return (
        t(`pages.clientsShow.featureFlags.${event._to}`) +
        ' ' +
        t(`pages.clientsShow.eventTypes.${event.type}`, {
          context: 'n',
        })
      );

    case 'featureFlags/15':
      return (
        t(`pages.clientsShow.featureFlags.${event._to}`) +
        ' ' +
        t(`pages.clientsShow.eventTypes.${event.type}`, {
          context: 'f',
        })
      );

    case 'featureFlags/14':
      return (
        t(`pages.clientsShow.featureFlags.${event._to}`) +
        ' ' +
        t(`pages.clientsShow.eventTypes.${event.type}`, {
          context: 'f',
        })
      );

    case 'featureFlags/10': {
      const firstPart = t(`pages.clientsShow.featureFlags.${event._to}`);
      const secondPart = !!parsedExtras?.screen
        ? ', ' +
          t(`pages.clientsShow.eventTypes.${event.type}`, {
            context: 'm',
          }) +
          ` ${t(`pages.clientsShow.screen`)}`
        : `, ${t(`pages.clientsShow.eventTypes.${event.type}`, {
            context: 'f',
          })}`;
      const thirdPart = parsedExtras?.screen
        ? parsedExtras?.video
          ? ` "${t(`screens.${parsedExtras.screen}`)}"` +
            `, videoId: ${parsedExtras.video}`
          : ` "${t(`screens.${parsedExtras.screen}`)}"`
        : '';

      return firstPart + secondPart + thirdPart;
    }
    case 'featureFlags/8': {
      return (
        t(`pages.clientsShow.featureFlags.${event._to}`) +
        ' ' +
        t(`pages.clientsShow.eventTypes.${event.type}`, {
          context: 'f',
        }) +
        (parsedExtras?.url ? `, ${parsedExtras.url}` : '')
      );
    }
    case 'featureFlags/3':
      return t(`pages.clientsShow.featureFlags.${event._to}`);
    case 'featureFlags/2':
      return (
        t(`pages.clientsShow.featureFlags.${event._to}`) +
        ' ' +
        t(`pages.clientsShow.eventTypes.${event.type}`, {
          context: 'n',
        }) +
        (parsedExtras?.article ? `, "${parsedExtras.article}"` : '')
      );
    default:
      return (
        t(`pages.clientsShow.featureFlags.${event._to}`) +
        ' ' +
        t(`pages.clientsShow.eventTypes.${event.type}`)
      );
  }
};
